(() => {
  const stage = document.querySelector('.founders-film-stage');
  const poster = stage?.querySelector('.founders-film-poster');
  const video = stage?.querySelector('video');
  if (!poster || !video) return;

  poster.addEventListener('click', () => {
    poster.hidden = true;
    video.hidden = false;
    video.preload = 'metadata';
    video.tabIndex = 0;
    video.focus();
    video.play().catch(() => video.focus());
  });

  const rail = document.querySelector('#story-rail');
  const previous = document.querySelector('.rail-prev');
  const next = document.querySelector('.rail-next');
  const reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)');
  if (rail && previous && next) {
    const updateRailControls = () => {
      previous.disabled = rail.scrollLeft < 3;
      next.disabled = rail.scrollLeft + rail.clientWidth >= rail.scrollWidth - 3;
    };
    const moveRail = direction => {
      const card = rail.querySelector('.community-card');
      if (!card) return;
      const gap = parseFloat(getComputedStyle(rail).gap) || 0;
      rail.scrollBy({ left: direction * (card.getBoundingClientRect().width + gap), behavior: reducedMotion.matches ? 'auto' : 'smooth' });
    };
    previous.addEventListener('click', () => moveRail(-1));
    next.addEventListener('click', () => moveRail(1));
    rail.addEventListener('scroll', updateRailControls, { passive: true });
    window.addEventListener('resize', updateRailControls);
    updateRailControls();
  }

  const dialog = document.querySelector('.story-dialog');
  const storyPlayer = dialog?.querySelector('video');
  const storySource = storyPlayer?.querySelector('source');
  const storyTitle = dialog?.querySelector('#story-dialog-title');
  const closeStory = dialog?.querySelector('.story-dialog-close');
  let lastTrigger = null;
  if (dialog && storyPlayer && storySource && storyTitle && closeStory) {
    document.querySelectorAll('.community-video-button').forEach(button => {
      button.addEventListener('click', () => {
        lastTrigger = button;
        storyTitle.textContent = button.dataset.storyTitle || 'Community video';
        storyPlayer.setAttribute('aria-label', storyTitle.textContent);
        storyPlayer.poster = button.dataset.storyPoster || '';
        storySource.src = button.dataset.storySrc;
        storyPlayer.load();
        dialog.showModal();
        closeStory.focus();
        storyPlayer.play().catch(() => {});
      });
    });
    closeStory.addEventListener('click', () => dialog.close());
    dialog.addEventListener('click', event => { if (event.target === dialog) dialog.close(); });
    dialog.addEventListener('close', () => {
      storyPlayer.pause();
      storySource.removeAttribute('src');
      storyPlayer.load();
      lastTrigger?.focus();
    });
  }

  if (!reducedMotion.matches && 'IntersectionObserver' in window) {
    const reveal = document.querySelectorAll('.founders-note, .community-heading, .community-card, .featured-story-bottom');
    const observer = new IntersectionObserver(entries => {
      entries.forEach(entry => {
        if (!entry.isIntersecting) return;
        entry.target.classList.add('is-visible');
        observer.unobserve(entry.target);
      });
    }, { rootMargin: '0px 0px -24px 0px', threshold: .12 });
    reveal.forEach(element => {
      element.classList.add('story-reveal');
      observer.observe(element);
    });
  }
})();
